module.exports = __webpack_public_path__ + "img/logo-em2.96bcc90c.png";